<div class="container-column section">
    <section>Projects</section>
</div>
<div class="card-container card" style="overflow-y: auto;">
    <!-- <kendo-textbox [style.width.px]="width" style="margin-bottom: 5px;" placeholder="Search..."
        (valueChange)="onFilter($event)"></kendo-textbox> -->
    <kendo-grid class="content1" [kendoGridBinding]="projects" kendoGridSelectBy="projectId"
        [(selectedKeys)]="selection" [selectable]="{ mode: 'single'}" [sortable]="true" [reorderable]="true"
        [resizable]="true" [columnMenu]="{ filter: true }" [loading]="loading" (excelExport)="onExcelExport($event)">
        <ng-template kendoGridToolbarTemplate>
            <button type="button" class="allbuttons" kendoGridExcelCommand [svgIcon]="svgIcon[1]">
                Export
            </button>
        </ng-template>
        <kendo-grid-column field="projectId" title="Project ID" [width]="115"></kendo-grid-column>
        <kendo-grid-column field="projectname" title="Project Name" [width]="250"></kendo-grid-column>
        <kendo-grid-column field="pocount" title="Orders" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span title="Clicking the count will navigate you to the Orders tab."
                    style="cursor: pointer;color: #1825aa !important"
                    (click)="navigate('purchase-orders', dataItem.pocount, dataItem)">
                    {{ dataItem.pocount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="totalpocount" title="Orders(No Access)" [width]="175" *ngIf="displayOrderNoAcceess">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span title="Clicking the count will navigate you to the Orders tab."
                    style="cursor: pointer;color: #1825aa !important"
                    (click)="navigate('purchase-orders', dataItem.pocount, dataItem)">
                    {{ getNoAccessColumnData(dataItem) }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="draftcount" title="Drafts" [width]="105">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>
                    {{ dataItem.draftcount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="pendingcount" title="Pending Acknowledgement" [width]="225">
            <ng-template kendoGridCellTemplate let-dataItem>
                <!-- <span [ngClass]="{'color1': dataItem.totalpocount == 0}" style="cursor: pointer;">
                    {{ dataItem.pendingcount }}
                </span> -->
                <span>
                    {{ dataItem.pendingcount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="totaluploadcount" title="All Submittals" [width]="140">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>
                    {{ dataItem.totaluploadcount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="filecount" title="All Files" [width]="105">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span>
                    {{ dataItem.filecount }}
                </span>
            </ng-template>
        </kendo-grid-column>
        <!-- <kendo-grid-column field="totaluploadcount" title="All Submittals & Files" [width]="184"></kendo-grid-column> -->
        <kendo-grid-column field="maxuploaddate" title="Last Submittal Date" [width]="175">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.maxuploaddate | date:'dd-MMM-yyyy' }}
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            <div style="height: 313px;background-color: rgb(215 212 212 / 20%);">
                <kendo-svgicon [icon]="svgIcon[0]" size="xxxlarge"></kendo-svgicon>
                <p>There is no data to display here.
                </p>
            </div>
        </ng-template>
        <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
    </kendo-grid>
</div>